import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { useContent } from "../../context/ContentContext";

const LINKS = [
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/products", label: "Products" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { site } = useContent();
  const logos = site.logos || {};

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled ? "border-b border-white/10 bg-black/60 backdrop-blur-xl" : "border-b border-transparent"
      }`}
      data-testid="site-navbar"
    >
      <nav className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-5 md:px-10">
        <Logo scrolled={scrolled} gradientSrc={logos.name} whiteSrc={logos.name_white} />

        <div className="hidden items-center gap-10 md:flex">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-medium uppercase tracking-widest transition-colors duration-300 ${
                  isActive ? "text-volt" : "text-white/60 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-cta-button"
            className="brand-gradient rounded-full px-5 py-2.5 text-sm font-semibold text-white transition-transform duration-300 hover:-translate-y-0.5"
          >
            Start a project
          </Link>
        </div>

        <button
          className="text-white md:hidden"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div className="border-t border-white/10 bg-korio-bg/95 px-6 py-8 md:hidden" data-testid="mobile-menu">
          <div className="flex flex-col gap-6">
            {LINKS.map((l) => (
              <NavLink key={l.to} to={l.to} className="font-display text-3xl uppercase text-white">
                {l.label}
              </NavLink>
            ))}
            <Link to="/contact" className="brand-gradient mt-2 inline-block rounded-full px-6 py-3 text-center font-semibold text-white">
              Start a project
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};
